var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#F3F3F3"}},[_c('v-app-bar',{attrs:{"app":"","color":"blue","dark":""}},[_c('span',{staticClass:"mr-2"},[_vm._v("Painel de Clientes")])]),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }